'use client'

import { useContext } from 'react'
import { ObservabilityContext } from './ObservabilityProvider'
import type { ObservabilityMethods } from '../types'

export function useObservability(): ObservabilityMethods {
    return useContext(ObservabilityContext)
}
